<template>
  <q-page padding>
    <div class="row col-12 justify-between items-center">
      <span class="text-h6 text-weight-bold text-brand-1 texto-titulo">
        Histórico Picking: #{{ voucherId }}
      </span>
      <router-link
        :to="{
          name: 'requisicao-detalhe',
          params: { requisicaoId: voucherId },
        }"
      >
        <div
          style="cursor: pointer"
          class="row items-center text-weight-bold text-brand-5 container-link-voltar q-mr-md"
        >
          <q-icon class="q-mr-sm icon-texto" name="west" color="brand-5" />
          <span class="texto-titulo">Voltar</span>
        </div>
      </router-link>
    </div>
    <div class="q-mt-xl">
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        table-header-class="bg-accent text-weight-bold"
        flat
        :columns="columns"
        dense
        :rows="listaHistorico"
        hide-bottom
        :rows-per-page-options="[0]"
        :class="{ 'my-sticky-dynamic': !mobile }"
        :grid="mobile"
        no-data-label="Nenhum histórico encontrado."
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card class="container-grid-table col-12">
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Numero Picking:</strong>
                      <span> {{ props.row.numeroPicking }}</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Origem Picking:</strong>
                      <span> {{ props.row.unidadeOrigem }}</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Destino Picking:</strong>
                      <span> {{ props.row.unidadeDestino }}</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Operação:</strong>
                      <span>
                        {{
                          props.row.operacao == "criado"
                            ? "Criação"
                            : props.row.operacao == "separado"
                            ? "Separação"
                            : props.row.operacao == "em transito"
                            ? "Envio"
                            : props.row.operacao == "cancelado"
                            ? "Cancelado"
                            : props.row.operacao == "entregue"
                            ? "Recebimento"
                            : ""
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Data:</strong>
                      <span>
                        {{
                          props.row.data
                            ?.split(" ")[0]
                            ?.split("-")
                            ?.reverse()
                            ?.join("/")
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Hora:</strong>
                      <span> {{ props.row.data?.split(" ")[1] }}</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Nome:</strong>
                      <span> {{ props.row.usuarioOperacaoNome }}</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Matricula:</strong>
                      <span> {{ props.row.usuarioOperacaoMatricula }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              {{ props.row.numeroPicking }}
            </q-td>
            <q-td>
              {{ props.row.unidadeOrigem }}
            </q-td>
            <q-td>
              {{ props.row.unidadeDestino }}
            </q-td>
            <q-td>
              {{
                props.row.operacao == "criado"
                  ? "Criação"
                  : props.row.operacao == "separado"
                  ? "Separação"
                  : props.row.operacao == "em transito"
                  ? "Envio"
                  : props.row.operacao == "cancelado"
                  ? "Cancelado"
                  : props.row.operacao == "entregue"
                  ? "Recebimento"
                  : ""
              }}
            </q-td>
            <q-td>
              <div>
                {{
                  props.row.data
                    ?.split(" ")[0]
                    ?.split("-")
                    ?.reverse()
                    ?.join("/")
                }}
              </div>
              <div class="q-ml-sm">
                {{ props.row.data?.split(" ")[1] }}
              </div>
            </q-td>
            <q-td>
              <div>
                {{ `Nome: ${props.row.usuarioOperacaoNome}` }}
              </div>
              <div>
                {{ `Matrícula: ${props.row.usuarioOperacaoMatricula}` }}
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script setup>
import { useQuasar } from "quasar";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();
const quasar = useQuasar();

const columns = [
  {
    name: "numeroPicking",
    label: "Numero Picking",
    align: "left",
  },
  {
    name: "origemPicking",
    label: "Origem Picking",
    align: "left",
  },
  {
    name: "destinoPicking",
    label: "Destino Picking",
    align: "left",
  },
  {
    name: "operacao",
    label: "Operação",
    align: "left",
  },
  {
    name: "data",
    label: "Data",
    align: "left",
  },
  {
    name: "usuarioOperador",
    label: "Usuário Operador",
    align: "left",
  },
];
const voucherId = route.params.voucherId;
const listaHistorico = ref([]);
const mobile = ref(false);
const loading = ref(false);

if (quasar.platform.is.mobile) {
  mobile.value = true;
}

const listarHistoricoPicking = async () => {
  loading.value = true;
  try {
    const response = await store.dispatch("pkg/getHistoricoPicking", {
      voucherId,
    });

    listaHistorico.value = response.data.result;
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  listarHistoricoPicking();
});
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
a {
  text-decoration: none;
}
.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-texto {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-texto {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
